var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"materials-cart-button"},[_c('i',{staticClass:"esi esi-cart"}),_c('easyscreen-badge',{staticClass:"materials-cart-button--badge",attrs:{"color":"primary","type":"circle"}},[_vm._v(" "+_vm._s(_vm.materials.length)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }